module.exports = "/virtual-football-league/img/video/video-jackpot.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/video-jackpot.png
// module id = 361
// module chunks = 4